<template>
  <div class="google-map" ref="googleMap"></div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";
import CommonMixin         from "@/mixins/commonMixin";

export default {
    name  : 'AreaMap',
    mixins: [CommonMixin],
    data() {
      return {
        /**
         * Google Maps API KEY
         */
        API_KEY  : process.env.VUE_APP_GOOGLE_MAP_API_KEY ? process.env.VUE_APP_GOOGLE_MAP_API_KEY : '',
        /**
         * MAPTILERへのURL
         */
        MAPTILER_URL  : process.env.VUE_APP_MAPTILER_URL ? process.env.VUE_APP_MAPTILER_URL : '',
        /**
         * タイル画像系の定数
         */
        TILE     : {
          ZOOM: 17, // タイル画像が流用に切り替わるズームレベル
          SIZE: {
            17: 512,
            18: 1024,
            19: 2048,
            20: 4096,
            21: 8192,
            22: 16384,
          }, // タイルのサイズ（ズームレベルごと）
        },
        /**
         * 地図の初期値
         */
        mapConfig: {
          center               : {
            lat: 35.710141,
            lng: 139.816475
          },
          zoom                 : 10,
          minZoom              : 6,
          maxZoom              : 16,
          mapTypeId            : 'roadmap',
          draggable            : true,
          gestureHandling      : 'auto',
          zoomControl          : true,
          rotateControl        : false,
          clickableIcons       : false,
          streetViewControl    : false,
          mapTypeControl       : false,
          // 地図の移動範囲を日本のみに制限
          restriction          : {
            latLngBounds: {
              north: 50,
              south: 20,
              west : 120,
              east : 155,
            },
            strictBounds: true,
          },
        },
        /**
         * Google Maps Platform
         */
        google   : null,
        /**
         * 地図
         */
        map      : null,
      }
    },
    mounted: async function () {
      await this.init();
    },
    methods: {
      /**
       * Google Map 初期化
       *
       * @returns {Promise<void>}
       */
      init              : async function () {
        this.google = await GoogleMapsApiLoader({apiKey: this.API_KEY});
        this.map    = new this.google.maps.Map(this.$refs.googleMap, this.mapConfig);
        this.setTile();
      },
      /**
       * タイル画像をオーバーレイ表示
       */
      setTile           : function () {
        const self = this;
        this.map.addListener('zoom_changed', function () {
          self.changeTile();
        });
        this.map.addListener('tilesloaded', function () {
          self.changeTile();
        });
      },
      /**
       * タイル切り替え
       */
      changeTile        : function () {
        const zoom = this.map.getZoom();
        this.removeTile();
        if (zoom >= this.TILE.ZOOM) {
          this.overlayNATile(zoom, this.TILE.SIZE[zoom], this.TILE.ZOOM - 1);
        } else if (zoom < this.TILE.ZOOM) {
          this.overlayNATile(zoom, 256);
        }
      },
      /**
       * 地図上からタイルデータを削除する
       */
      removeTile        : function () {
        this.map.overlayMapTypes.clear();
      },
      /**
       * NAタイルをオーバーレイ表示する
       *
       * @param zoom
       * @param size
       * @param zoomResource
       */
      overlayNATile     : function (zoom, size, zoomResource) {
        const self      = this;
        const naMapType = new this.google.maps.ImageMapType({
          getTileUrl: function (coord, zoom) {
            const normalizedCoord = self.getNormalizedCoord(coord, zoom);
            if (!normalizedCoord) {
              return null;
            }

            return self.MAPTILER_URL
                .replace('{z}', (zoomResource ? zoomResource : zoom))
                .replace('{x}', normalizedCoord.x)
                .replace('{y}', normalizedCoord.y);
          },
          tileSize  : new this.google.maps.Size(size, size),
          maxZoom   : zoom,
          minZoom   : zoom
        });
        this.map.overlayMapTypes.push(naMapType);
      },
      /**
       * 座標を正規化
       *
       * @param coord
       * @param zoom
       * @returns {{x: number, y: *}|null}
       */
      getNormalizedCoord: function (coord, zoom) {
        const tileRange = 1 << zoom;
        let y           = coord.y;
        let x           = coord.x;

        if (y < 0 || y >= tileRange) {
          return null;
        }

        if (x < 0 || x >= tileRange) {
          x = (x % tileRange + tileRange) % tileRange;
        }

        return {x: x, y: y};
      },
    }
  }
</script>

<style lang="scss" scoped>
  .google-map {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
  }
</style>
